import { encode } from 'js-base64';
import type { RootState } from 'react-redux';

import type { ApiClient } from '@travel/api-client';
import generateLogger from '@travel/logger';

import type { AuthCodeError, AuthCodeItem } from 'AuthCode-Types';

import { postInHouseToken, postLogout, refreshToken } from './api';

import { createAsyncThunk } from '@reduxjs/toolkit';

const logger = generateLogger();

type ThunkExtra = {
  apiClient: ApiClient;
  history?: any;
  req?: any;
  res?: any;
};

// Fetch Auth Code
export const fetchAuthCode = createAsyncThunk<
  AuthCodeItem,
  string,
  { state: RootState; extra: ThunkExtra; rejectValue: AuthCodeError }
>('authCode/fetch', async (fIdSession: string, { extra, rejectWithValue }) => {
  const { apiClient } = extra;

  try {
    const authCode = await postInHouseToken(apiClient, encode(fIdSession));
    return authCode;
  } catch (error) {
    logger.info('Auth Code Fetch Failed', error);
    return rejectWithValue(error as AuthCodeError);
  }
});

// Refresh Auth Code
export const refreshAuthCode = createAsyncThunk<
  AuthCodeItem,
  void,
  { state: RootState; extra: ThunkExtra; rejectValue: AuthCodeError }
>('authCode/refresh', async (_arg, { getState, extra, rejectWithValue }) => {
  const { apiClient } = extra;
  const {
    _httpRequest: { normalizedCookies },
    authCode: { item },
  } = getState();

  if (!item?.token) {
    return rejectWithValue({ status: 0, message: 'No token available' } as AuthCodeError);
  }

  try {
    const authCode = await refreshToken(apiClient, encode(normalizedCookies.f_id_session.value));
    return authCode;
  } catch (error) {
    logger.error('Refresh Token Failed', error);
    return rejectWithValue(error as AuthCodeError);
  }
});

// Logout
export const logout = createAsyncThunk<
  AuthCodeItem,
  void,
  { extra: ThunkExtra; rejectValue: AuthCodeError }
>('authCode/logout', async (_, { rejectWithValue, extra }) => {
  const { apiClient } = extra;

  try {
    await postLogout(apiClient);
    return { token: '' };
  } catch (error) {
    logger.error('Logout Failed', error);
    return rejectWithValue(error as AuthCodeError);
  }
});
